import { render, staticRenderFns } from "./Upload-files.vue?vue&type=template&id=3162d9a5&"
import script from "./Upload-files.vue?vue&type=script&lang=js&"
export * from "./Upload-files.vue?vue&type=script&lang=js&"
import style0 from "./Upload-files.vue?vue&type=style&index=0&id=3162d9a5&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/williamsalmeida/www/hubcompras/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3162d9a5')) {
      api.createRecord('3162d9a5', component.options)
    } else {
      api.reload('3162d9a5', component.options)
    }
    module.hot.accept("./Upload-files.vue?vue&type=template&id=3162d9a5&", function () {
      api.rerender('3162d9a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/plugins/Upload-files.vue"
export default component.exports